import { render, staticRenderFns } from "./CabinetAddons.vue?vue&type=template&id=28333265&scoped=true&"
import script from "./CabinetAddons.vue?vue&type=script&lang=js&"
export * from "./CabinetAddons.vue?vue&type=script&lang=js&"
import style0 from "./CabinetAddons.vue?vue&type=style&index=0&id=28333265&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28333265",
  null
  
)

export default component.exports